import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import "react-toastify/dist/ReactToastify.css";
import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './Context/NoteState';
import NoInternet from './NoInternet';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <UserProvider>
      <BrowserRouter>
        <NoInternet>
            <App />
        </NoInternet>
      </BrowserRouter>
    </UserProvider>
  </React.StrictMode>
);

reportWebVitals();
